import React from "react";
import { Field, UseFieldConfig } from "react-final-form";
import FormCounter, { FormCounterProps } from "ui/Form/Counter";

type Props = FormCounterProps & UseFieldConfig<unknown[]>;

const CounterField: React.FC<Props> = ({
    labelProps,
    fieldGroupProps,
    fieldControlProps,
    inputProps,
    ...fieldProps
}) => {
    return (
        <Field name={inputProps.name} {...fieldProps}>
            {({ input, meta }) => {
                return (
                    <FormCounter
                        error={!!(meta.error || meta.submitError)}
                        errorMessage={meta.submitError}
                        labelProps={labelProps}
                        fieldGroupProps={fieldGroupProps}
                        fieldControlProps={fieldControlProps}
                        inputProps={Object.assign({}, input, inputProps)}
                    />
                );
            }}
        </Field>
    );
};

export default CounterField;
